import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Text } from '../text/Text.js';

var CheckImage = "data:image/svg+xml,%3Csvg width='14' height='11' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(-5 -7)' fill='none' fill-rule='evenodd'%3E%3Crect fill='none' width='24' height='24' rx='4'/%3E%3Cpath d='M17 7.34l-7.33 7.34-2.68-2.67a1.17 1.17 0 0 0-1.65 1.65l3.5 3.5c.46.45 1.2.45 1.65 0l8.17-8.17A1.17 1.17 0 0 0 17 7.34z' fill='%2377B203' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E";
var StyledInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "Checkbox__StyledInput",
  componentId: "sc-1eaj8kb-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  height: 25px;\n  width: 25px;\n  display: block;\n  padding: 0;\n  line-height: 25px;\n  border-radius: 5px;\n  background-color: #fff;\n  color: #fff;\n  text-align: center;\n  border: solid 2px ", ";\n  outline: 0;\n  margin: 0 0 0 0;\n  flex-shrink: 0;\n  appearance: none;\n  user-select: none;\n\n  &:checked {\n    border-color: ", ";\n    background-image: url(\"", "\");\n    background-position: 50%;\n    background-repeat: no-repeat;\n  }\n"], ["\n  cursor: pointer;\n  height: 25px;\n  width: 25px;\n  display: block;\n  padding: 0;\n  line-height: 25px;\n  border-radius: 5px;\n  background-color: #fff;\n  color: #fff;\n  text-align: center;\n  border: solid 2px ", ";\n  outline: 0;\n  margin: 0 0 0 0;\n  flex-shrink: 0;\n  appearance: none;\n  user-select: none;\n\n  &:checked {\n    border-color: ", ";\n    background-image: url(\"", "\");\n    background-position: 50%;\n    background-repeat: no-repeat;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.divider;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.mofoGreen;
}, CheckImage);
var Checkbox = function (_a) {
  var label = _a.label,
    rest = __rest(_a, ["label"]);
  var LabelComponent;
  if (typeof label === "string") {
    LabelComponent = React__default.createElement(Text, {
      as: "span",
      fontSize: 0
    }, label);
  } else {
    LabelComponent = label;
  }
  return React__default.createElement(Box, {
    as: "label",
    display: "flex",
    alignItems: "center",
    position: "relative"
  }, React__default.createElement(StyledInput, __assign({
    type: "checkbox"
  }, rest)), React__default.createElement(Box, {
    ml: "10px"
  }, LabelComponent));
};
var templateObject_1;

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
